import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

const TitleWrapperStyle = styled.div`
    label: TitleWrapperStyle;

    ${({ align }) => {
        if (align === "left") {
            return `
                    text-align: left;
                  `;
        }
        if (align === "center") {
            return `
                      text-align: center;
                `;
        }
        if (align === "right") {
            return `
                      text-align: right;
                `;
        }
    }};
`;
const Title = styled.h1`
    label: Title;

    font-family: Helvetica, sans-serif;
    font-weight: bold;

    ${({ theme }) => {
        if (theme === "blue") {
            return `
                color: #0098DB;
            `;
        }
        if (theme === "black") {
            return `
                color: #262626;
            `;
        }
        if (theme === "white") {
            return `
                color: #ffffff;
            `;
        }
    }};
    ${({ type }) => {
        if (type === "page-title") {
            return `
                font-size: 34pt;
                letter-spacing: 0.25px;
                line-height: auto;
              `;
        }
        if (type === "page-sub-title") {
            return `
                font-size: 18pt;
                letter-spacing: 0.25px;
                line-height: 48px;
              `;
        }
        if (type === "section-title") {
            return `
                font-size: 40px;
                letter-spacing: 0.25px;
                line-height: 48px;
            `;
        }
        if (type === "sub-title") {
            return `
                font-size: 16px;
                letter-spacing: 0;
                line-height: 32px;
            `;
        }
        if (type === "card-title") {
            return `
                font-size: 16pt;
                letter-spacing: 0;
                line-height: 32px;
            `;
        }
        if (type === "stone-title") {
            return `
                font-size: 24px;
                letter-spacing: 0;
                line-height: 28px;
                max-height: 180px;
                max-width: 200px;
                padding: 15px;
            `;
        }
    }};
`;
const TitleWrapper = ({ align, children, className, content, dataQa, heading, theme, type }) => (
    <TitleWrapperStyle
        data-qa={"content-section-main-title-" + dataQa}
        align={align}
        theme={theme}
        type={type}
        className={className}
    >
        <Title as={heading} align={align} theme={theme} type={type}>
            {content || children}
        </Title>
    </TitleWrapperStyle>
);

export const TitleWrapperPropTypes = {
    content: PropTypes.string,
    align: PropTypes.oneOf(["left", "center", "right"]),
    theme: PropTypes.oneOf(["blue", "black", "white"]),
    heading: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
    type: PropTypes.oneOf(["page-title", "page-sub-title", "section-title", "stone-title", "sub-title", "card-title"])
};
TitleWrapper.defaultProps = {
    align: "center",
    heading: "div",
    theme: "black",
    type: "section-title"
};
TitleWrapper.propsTypes = TitleWrapperPropTypes;
export default TitleWrapper;
